import * as React from 'react';
import { trackForwardedComponent } from '@drone-js/core';
import { BaseDatePicker as DatePicker } from './DatePicker.js';

DatePicker.displayName = 'DatePicker';
var DatePickerWithTracking = /*#__PURE__*/React.memo(trackForwardedComponent(DatePicker));
DatePickerWithTracking.displayName = 'DatePicker';

export { DatePicker as BaseDatePicker, DatePickerWithTracking as DatePicker };
//# sourceMappingURL=external.js.map
